export default __webpack_public_path__ + "022f8f150e8df6b8423ce6fbe5858811.png";